import type { ReportStatus } from '#shared/types';
import { describeDue, formatDateTime } from '#client/lib/format';

interface DueCellProps {
  due_at: string | null;
  report_status: ReportStatus;
  completed_at: string | null;
}

/**
 * When a report is due, or when it was finished.
 *
 * Completed work is described by when it landed, not by a deadline that no
 * longer applies — otherwise a report finished on time keeps showing "2 days
 * late" forever. The dashboard, the worklist and the patient record all render
 * this column and had three slightly different versions of that rule.
 */
export function DueCell({ due_at, report_status, completed_at }: DueCellProps) {
  if (report_status === 'completed') {
    return <span className="c-due c-due--ok tnum">{formatDateTime(completed_at)}</span>;
  }

  const due = describeDue(due_at);
  return <span className={`c-due c-due--${due.tone}`}>{due.label}</span>;
}
